import React from 'react'
import { FilterTypes } from '../../FilterCommon/Filter';
import { isErrorPc } from '@/component/PageComponent/errorPc';
import { SelectModalCommonPc } from '../Common/SelectListModalPc';
import { getCouponList, getDetail, CouponListResp, ThresholdType, GoodsScopeMap } from './service';
import { IssueModeType, IssueModeTypeMap } from '../FilterIssueMode/FilterIssueMode';
import { compact } from 'lodash';
import { getSearchTimestamp } from '@/component/common/report/report';


export interface FilterCouponProps {
  onChange? (value: any, option: any): void
  value: any
}

type RespListRow = CouponListResp['list'][0];

export function FilterCouponPc(props: FilterCouponProps) {

  const {...rest} = props
  let listKey = 'coupon_id'

  const getList = async (params: any)=>{
    let res =  await getCouponList({ 
      ...params,
      page: params.page - 1
     })
    if(isErrorPc(res)){
      return {
        list: [],
        count: 0,
      }
    }
    const dataList = res.data?.data?.list
    return {
      list: dataList.map(item => ({...item, face_value: item.value, label: item.name, value: item.coupon_id})), // 面值字段，后端返回的是value，字段冲突了，强行改为face_value
      count: res.data.data.count
    }
  }

  const getCouponDetail = async (params: { ids: string[] }) => {
    const { ids } = params;
    const promises = ids.map((id) => {
      return getDetail({
        coupon_id: id
      })
    })
    const results = await Promise.all(promises);
    const detailData = results.map((res) => {
      if(isErrorPc(res)) return undefined
      const dataItem = res.data?.data;
      return {
        label: dataItem.name,
        value: dataItem.coupon_id
      }
    })
    return compact(detailData)
  }

  const getComponentKey = () => {
    let componentKey = 'FilterCouponPc';
    const timeStamp = getSearchTimestamp();
    if (timeStamp) {
      componentKey = componentKey + timeStamp
    }
    return componentKey
  }

  return (
    <SelectModalCommonPc<RespListRow>
      {...rest} 
      listKey={listKey}
      getList={getList}
      getDetail={getCouponDetail}
      componentKey={getComponentKey()}
      SelectProps={{
        placeholder: '选择活动',
        mode: 'multiple',
      }}
      SelectListModalProps={{
        listKey:listKey,
        getList: getList,
        type:'checkbox',
        title:'选择活动',
        filterProps:{
          filters:[
            { type: FilterTypes.Input, dataIndex: 'kw',placeholder: '优惠券名称',},
            { type: FilterTypes.CouponStatus, dataIndex: 'status',placeholder: '优惠券状态', mode: undefined },
            { type: FilterTypes.IssueMode, dataIndex: 'grant_type',placeholder: '发放方式', mode: undefined },
            { type: FilterTypes.DatePick, dataIndex: 'start_time',placeholder: '开始日期' },
            { type: FilterTypes.DatePick, dataIndex: 'start_time_end',placeholder: '截止日期' },
          ],
        },
        columns: [
          {
            width: 50,
            dataIndex: 'sequence',
            render: (text: string, record: RespListRow, index: number) => {
              return index + 1;
            }
          },
          { width: '20%', title: '名称', dataIndex: "name" },
          { 
            width: '20%', 
            title: '有效日期', 
            dataIndex: "start_date", 
            render: (text: string, record: RespListRow) => {
              return (
                <div>
                  <div>{`${record.start_date} ~ ${record.end_date}`}</div>
                </div>
              )
            }
          }, 
          { width: '15%', title: '面值(元)', dataIndex: "face_value" }, 
          { 
            width: '15%', 
            title: '使用门槛', 
            dataIndex: "threshold",
            render: (text: string, row: RespListRow) => {
              const thresholdName = text == ThresholdType.unlimited ? '无门槛' : '满减';
              const isShow = row.threshold == ThresholdType.fullDown;
              return (
                <div>
                  <span>{thresholdName}</span>
                  {isShow && <span style={{ marginLeft: 10, color: 'red' }}>({row.threshold_value})</span>}
                </div>
              )
            }
          }, 
          { width: '15%', title: '状态', dataIndex: "status_name" }, 
          { 
            width: '15%', 
            title: '发放方式', 
            dataIndex: "grant_type",
            render: (text: string) => {
              if (text) {
                return IssueModeTypeMap[text]
              }
            }
          }, 
        ]
      }}
    />
  )
}
